window.addEventListener('load', () => {
  const commentForm = document.querySelector('#commentform')

  if(commentForm) {
    commentForm.noValidate = true

    commentForm.addEventListener('submit', (e) => {
      if (!commentForm.checkValidity()) {
        e.preventDefault()
        e.stopPropagation()
      }

      commentForm.classList.add('was-validated')
    }, false)
  }
})